import { Component, Input } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
    selector: 'live-video',
    templateUrl: './live-video.component.html',
    styleUrls: ['./live-video.component.scss'],
})
export class LiveVideoComponent {

    @Input() public videoWidth: string = '80%';
    @Input() public videoHeight: string = '219';
    @Input() public rounded: boolean = false;

    public urlSafe: SafeResourceUrl = '';

    private channelIdCurrent: string;
    private assessoriaId: string = 'UCxrB8yGIrTWPAN17knREhgA';

    @Input() public set channelId(channelId: string) {
        const cannelCurrent = !!channelId ? channelId : this.assessoriaId;

        this.channelIdCurrent = `https://www.youtube.com/embed/live_stream?channel=${cannelCurrent}&rel=0`;
    }

    constructor(public sanitizer: DomSanitizer) {
        //
    }

    public ngOnInit() {
        this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(this.channelIdCurrent);
    }

}
